import React, { useState, useEffect } from "react";
import MapCanvas from "./MapCanvas";
import MapControls from "./MapControls";
import MapKey from "./MapKey";
import MapDetail from "./MapDetail";
import LoadingDots from "../LoadingDots/LoadingDots";
import useFetchOnMount from "../hooks/useFetchOnMount/useFetchOnMount";

const SchoolMap = ({ api }) => {
  const [schools, setSchools] = useState([]);
  const [isFullScreen, setFullScreen] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(false);

  const fetchSchoolData = async () => {
    setFetching(true);
    try {
      const { results } = await api.call('schemas', 'searchResources', [1, "", 1, "*", "", true, true, false, "sites"]);
      setSchools(results);
    } catch (error) {
      console.log(error);
      setError(error);
    }
    setFetching(false);
  };

  useEffect(() => {
    if (isFullScreen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isFullScreen]);

  useFetchOnMount(fetchSchoolData);

  return (
    <div
      className={`bg-white p-5 aspect-ratio aspect-ratio-16by9 aspect-ratio-xl aspect-ratio-21by9-xl ${
        isFullScreen
          ? "w-100 h-100 position-fixed fixed-top"
          : "d-none d-sm-block"
      }`}
    >
      {fetching ? (
        <div className="aspect-ratio-content d-flex flex-row h-100 align-items-center justify-content-center">
          <LoadingDots spinnerClass="bg-primary" />
        </div>
      ) : error ? (
        <div className="aspect-ratio-content d-flex flex-row h-100 align-items-center justify-content-center">
          Something went Wrong!
          <br />
          {JSON.stringify(error)}
        </div>
      ) : (
        <div className="aspect-ratio-content">
          <MapControls
            isFullScreen={isFullScreen}
            setFullScreen={setFullScreen}
            setSelectedSchool={setSelectedSchool}
            schools={schools}
          />
          {selectedSchool ? (
            <MapDetail
              setSelectedSchool={setSelectedSchool}
              school={selectedSchool}
              api={api}
            />
          ) : null}
          <MapKey />
          <MapCanvas
            selectedSchool={selectedSchool}
            schoolSelection={setSelectedSchool}
            schools={schools}
          />
        </div>
      )}
    </div>
  );
};

export default SchoolMap;



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolMap/SchoolMap.js